import {
  Box
} from '@chakra-ui/react';
import EmployeeTasksTable from './components/EmployeeTasksTable';

export default function EmployeeTasks() {
  return (
    <Box pt={{ base: "40px", md: "80px", xl: "78px" }} px={{ base: 1, md: 4 }}>
      <EmployeeTasksTable />
    </Box>
  );
}
